/* istanbul ignore file */
import styled, { css } from 'styled-components';
import { Box } from '@rebass/grid';

import { Container } from 'app/shared/ui';

import { media } from '../../../../styles_js/variables';

export const ContainerSt = styled(Container)`
  width: 100%;
  ${media.md(css`
    width: 712px;
  `)};
  ${media.lg(css`
    width: 952px;
  `)};
  ${media.xl(css`
    width: 1168px;
  `)};
`;

export const FullContainerSt = styled(Box)`
  background: ${({ hasHalfBg, theme: { colors } }) =>
    !hasHalfBg
      ? colors.graySuperLight
      : `linear-gradient(180deg, ${colors.graySuperLight} 210px, #fff 10px);`};
  color: ${({ theme: { colors } }) => colors.brandSecondary};

  padding-top: 0;

  ${media.md(css`
    padding-top: ${({ pt }) => (pt && `${pt}px`) || 0};
  `)};
`;

export const ImageSt = styled(Container)`
  position: relative;
  background: url('/assets/home/stage-new.webp') center;
  background-size: contain;
  background-repeat: no-repeat;
  max-width: 700px;
  width: 100%;
  min-height: 320px;
  background-position-y: 77px;
`;

export const MainHeadingH1St = styled.h1`
  display: none;
  padding-top: 8px;
  margin-bottom: 48px;
  position: relative;
  text-align: center;
  height: 40px;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: ${({ theme: { colors } }) => colors.tarmacGrey};

  &::before {
    position: absolute;
    top: 0;
    left: calc(50% - 22.5px);
    width: 45px;
    height: 4px;
    background-color: #00cea5;
    content: '';
  }

  ${media.md(css`
    display: block;
  `)};
`;

export const RectangleSt = styled.div`
  width: 100%;
  height: 100%;
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  overflow: visible;

  ${media.md(css`
    overflow: hidden;
    overflow-y: auto;
    margin: 0 auto;
    height: 544px;
    max-width: 568px;
  `)}
`;

export const HideOnMobile = styled.div`
  display: none;

  ${media.md(css`
    display: block;
  `)};
`;

export const AdvantagesWrapperSt = styled.div`
  height: 100%;
  width: 100%;
  display: none;

  ${media.md(css`
    display: flex;
  `)};

  & > div {
    max-width: 580px;
    width: 100%;
    margin: auto;
  }
`;
